import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/** Maps internal reason codes to user-friendly labels + tooltips */
const REASON_MAP: Record<string, { label: string; tooltip: string }> = {
  not_used_lexicographic: {
    label: 'Not used',
    tooltip: 'This metric is not used in the current proficiency-first ranking model',
  },
  not_comeback_ticket: {
    label: 'N/A',
    tooltip: 'Comeback bonus only applies to comeback tickets',
  },
  diagnostics_only: {
    label: 'Diag only',
    tooltip: 'Only calculated for diagnostic job types',
  },
  no_historical_data: {
    label: 'No history',
    tooltip: 'No historical completion data found for this technician + job combination',
  },
  catalyst_not_enabled: {
    label: 'Catalyst only',
    tooltip: 'Catalyst learning is not enabled for this shop tier',
  },
  preview_mode: {
    label: 'Preview',
    tooltip: 'Not available in preview/pre-creation mode',
  },
  no_optitime_available: {
    label: 'No Tech OptiTime',
    tooltip: 'Tech OptiTime estimate was not available for this technician',
  },
  config_disabled: {
    label: 'Disabled',
    tooltip: 'This feature is disabled in shop configuration',
  },
};

interface MissingReasonChipProps {
  reasonCode: string | null | undefined;
}

export function MissingReasonChip({ reasonCode }: MissingReasonChipProps) {
  if (!reasonCode) {
    return <span className="text-muted-foreground/50">—</span>;
  }

  const info = REASON_MAP[reasonCode] || {
    label: reasonCode.replace(/_/g, ' '),
    tooltip: reasonCode.replace(/_/g, ' '),
  };

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center rounded bg-muted/60 px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground cursor-help whitespace-nowrap">
            {info.label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[220px] text-xs">
          {info.tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
